import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import App from './App';
import './index.css';

const domain: string = import.meta.env.VITE_AUTH0_DOMAIN || 'login.themousy.org';
const clientId: string = import.meta.env.VITE_AUTH0_CLIENT_ID || 'XNl9WvvDRuphmT9ReqkLYBWxhvTDUGo6';

const onRedirectCallback = (appState?: AppState): void => {
    console.log('TheMousy Web - Callback completed', appState);
    // Navigate to where user was trying to go, or home
    window.location.href = appState?.returnTo || '/';
};

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <BrowserRouter>
            <Auth0Provider
                domain={domain}
                clientId={clientId}
                authorizationParams={{
                    redirect_uri: `${window.location.origin}/callback`, // Use dedicated callback route
                    scope: 'openid profile email'
                }}
                onRedirectCallback={onRedirectCallback}
                cacheLocation="localstorage"
                useRefreshTokens={true}
            >
                <App />
            </Auth0Provider>
        </BrowserRouter>
    </StrictMode>
);